"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var Image = function Image(_ref) {
  var href = _ref.href,
      imageStyle = _ref.imageStyle,
      image = _ref.image,
      rootClass = _ref.rootClass,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      height = _ref.height,
      width = _ref.width;

  var styles = _Storyblok.default.anchorOrginToObj(rootClass);

  var imageStyles = _Storyblok.default.anchorOrginToObj(imageStyle);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: storyblokClass,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid,
    style: {
      height: height,
      width: width
    }
  }, href && /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: "_self"
  }, /*#__PURE__*/_react.default.createElement("picture", {
    style: styles
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    style: imageStyles,
    alt: image
  }))), !href && /*#__PURE__*/_react.default.createElement("picture", {
    style: styles
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    style: imageStyles,
    alt: image
  })));
};

var _default = Image;
exports.default = _default;
Image.propTypes = {
  /**
   * Url for image to be displayed.
   */
  image: _propTypes.default.string.isRequired,

  /**
   * Url for image to be displayed.
   */
  href: _propTypes.default.string,

  /**
   * Height of the App Bar must use 'px', 'em', '%' 'vh', 'vw', as unit of measurement
   * */
  height: function height(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * 'px', 'em', '%' 'vh', 'vw', as unit of measurement
   */
  width: function width(props, propName, componentName) {
    return (0, _customProps.dimensionProp)(props, propName, componentName);
  },

  /**
   * Css Styles for the image.
   */
  imageStyle: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * Css Styles for the image.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),
  dataBlokC: _propTypes.default.string,
  dataBlokUid: _propTypes.default.string,
  storyblokClass: _propTypes.default.string
};
Image.defaultProps = {
  height: '500px',
  width: '500px',
  imageStyle: [],
  rootClass: [],
  href: null,
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};